import { Banner } from "@/components/Banner";
import { CardBox } from "../CardBox";
import { Typography } from "../Typography";
import { BenefitsModuleProps } from "./types";

import "./styles.scss";

export const BenefitsMoodule = ({ data, wrapperSize, setSource }: BenefitsModuleProps) => {
  const { richtext, list, backgroundColor, amplitudeEvent } = data;
  return (
    <Banner
      big
      light
      wrapperSize={wrapperSize}
      customBgColor={backgroundColor}
      customClass="banner-cards">
      <div className="benefits-module">
        <div className="benefits-module-header">
          {richtext.map((item, i: number) => (
            <Typography
              key={i}
              Tag={item.tag}
              size={item.size}
              spacing={item.spacing}>
              {item.list
                ? item.list.map((e, i) => (
                    <li key={i}>{<span dangerouslySetInnerHTML={{ __html: e["item"] }}></span>}</li>
                  ))
                : item.content}
            </Typography>
          ))}
        </div>
        <div className="benefits-module-content">
          {list.map((item, i) => (
            <CardBox
              item={item}
              key={i}
              shadow
              className="benefits-card"
              amplitudeEvent={amplitudeEvent}
              setSource={setSource}
            />
          ))}
        </div>
      </div>
    </Banner>
  );
};
